export default "__VITE_ASSET__45de4b85__"